import React, { Component } from 'react'
import PropTypes from 'prop-types'
import lightwallet from 'eth-lightwallet'
import { connect } from 'react-redux'
import FileSaver from 'file-saver'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import { loginUser } from '../../user/actions/LoginAction'
import {
  Button,
  Container,
  Header,
  Segment,
  Form,
  Message,
  Modal
} from 'semantic-ui-react'

class Wallet extends Component {

    constructor(props) {
        super(props)

        this.state = {
            inputPassword: '',
            inputConfirmPassword: '',
            checkPassword: '',
            checkConfirmPassword: '',
            inputSeed: '',
            seed: '',
            restoreWallet: 'cr',
            errorMessage: false,
            errorMessageText: '',
            showModal: false,
            checkLoading: false,
            checkErrorMessage: false,
            checkErrorMessageText: '',
            copySuccess: false
        }
    }

    copyToClipboard() {

        this.setState({ copySuccess: true });

        this.timeout = setTimeout(() => {
            this.setState({ copySuccess: false })
        }, 1500)
    }
  
    passwordOnInputChange(event) {
        this.setState({ inputPassword: event.target.value})
    }
	
    passwordConfirmOnInputChange(event) {
        this.setState({ inputConfirmPassword: event.target.value})
    }
	
    seedOnInputChange(event) {
        this.setState({ inputSeed: event.target.value})
    }
	
    checkPasswordOnInputChange(event) {
        this.setState({ checkPassword: event.target.value})
    }
	
    checkPasswordConfirmOnInputChange(event) {
        this.setState({ checkConfirmPassword: event.target.value})
    }
	
    continueSubmit(event) {
        event.preventDefault()
		
        let password = this.state.inputPassword
        let randomSeed = this.state.seed
		
        let that = this
					
        lightwallet.keystore.createVault({password: password, seedPhrase: randomSeed, hdPathString: "m/44'/60'/0'/0"}, function (err, ks) {
            ks.keyFromPassword(password, function(err, pwDerivedKey) {
                ks.generateNewAddress(pwDerivedKey);
				
                let { dispatch } = that.props
                let action = loginUser(ks.serialize())
                dispatch(action)
            })
        })
    }
	
    downloadWallet(event) {
        event.preventDefault()
		
        let password = this.state.inputPassword
        let randomSeed = this.state.seed
						
        lightwallet.keystore.createVault({password: password, seedPhrase: randomSeed, hdPathString: "m/44'/60'/0'/0"}, function (err, ks) {
            ks.keyFromPassword(password, function(err, pwDerivedKey) {
                ks.generateNewAddress(pwDerivedKey);
                let address = ks.getAddresses()
				
                let blob = new Blob([ks.serialize()], {type: "text/plain;charset=utf-8"})
                FileSaver.saveAs(blob, "dac_wallet_"+address[0]+".txt")				
            })
        })
    }

    inputPasswordSubmit(event) {
        event.preventDefault()
		
        let password = this.state.inputPassword
        let passwordRepeat = this.state.inputConfirmPassword
        if (password.length < 6){
            this.setState({ errorMessage: true, errorMessageText: 'Password not long enough.' })
            return
        }
        if (password !== passwordRepeat){
            this.setState({ errorMessage: true, errorMessageText: 'Passwords don\'t match.' })
            return
        }
		
        let randomSeed = lightwallet.keystore.generateRandomSeed()
        this.setState({ errorMessage: false, seed: randomSeed, restoreWallet: 'dn'})	
    }
	
    inputSeedSubmit(event) {
        event.preventDefault()
		
        let seed = this.state.inputSeed

        if (!lightwallet.keystore.isSeedValid(seed)){
            this.setState({ errorMessage: true, errorMessageText: 'Seed is wrong.' })
            return
        }
		
        this.setState({ errorMessage: false, showModal: true})
    }
	
    checkPasswordSubmit(event) {
        event.preventDefault()
		
        let seed = this.state.inputSeed
		
        let password = this.state.checkPassword
        let passwordRepeat = this.state.checkConfirmPassword
		
        if (password.length < 6){
            this.setState({ checkErrorMessage: true, checkErrorMessageText: 'Password not long enough.' })
            return
        }
        if (password !== passwordRepeat){
            this.setState({ checkErrorMessage: true, checkErrorMessageText: 'Passwords don\'t match.' })
            return
        }
		
        this.setState({ checkLoading: true, checkErrorMessage: false })

        let that = this
		
        lightwallet.keystore.createVault({password: password, seedPhrase: seed, hdPathString: "m/44'/60'/0'/0"}, function(err, ks) {
            ks.keyFromPassword(password, function(err, pwDerivedKey) {
                ks.generateNewAddress(pwDerivedKey);

                let { dispatch } = that.props
                let action = loginUser(ks.serialize())
                dispatch(action)
            })
        })
    }
	
    walletOnInputChange(event) {
        event.preventDefault()
		
        let files = event.target.files;
        if (!files.length) {

            return;
        }
		
        let filePath = event.target.value;
        let allowedExtensions = /(\.txt)$/i;
        if(!allowedExtensions.exec(filePath)){
			
            this.setState({ errorMessage: true, errorMessageText: 'Please upload DAC wallet file with .txt extension.' })
            return
        }
		
        let file = files[0];
        let reader = new FileReader();
        let that = this
		
        reader.onload = function(e) {
            let ks = lightwallet.keystore.deserialize(e.target.result)
			
            let { dispatch } = that.props
            let action = loginUser(ks.serialize())
            dispatch(action)
        };
        reader.readAsText(file);
    }
	
    render() { 
        if(this.state.restoreWallet === 'rs') { 
            return(
                <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                    <Container>
                        <Header as='h1' content='Restore Wallet' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                        <Container textAlign='left' text>
                            <Message error hidden={!this.state.errorMessage} content={this.state.errorMessageText}/>
                            <Form size='large' onSubmit={this.inputSeedSubmit.bind(this)}>
                                <Form.Field>
                                    <label>Seed</label>
                                    <input placeholder='Enter your wallet seed' value={this.state.inputSeed} onChange={this.seedOnInputChange.bind(this)} />
                                </Form.Field>
                                <Button.Group size='large'>
                                    <Button positive type='submit'>Restore</Button><Button.Or/><label className='ui positive button' htmlFor="file">Upload</label><Button.Or/><Button negative type='reset' onClick={() => this.setState({restoreWallet: 'cr', errorMessage: false, inputSeed: ''})}>Cancel</Button>
                                </Button.Group>
                                <input name='file' id='file' onChange={this.walletOnInputChange.bind(this)} style={{width: '0.1px',height: '0.1px',opacity: '0',overflow: 'hidden',position: 'absolute',zIndex: '-1'}} autoComplete='off' type="file" accept=".txt"/>
                            </Form>
                        </Container>
                    </Container>
                    <Modal size='mini' open={this.state.showModal} onClose={() => this.setState({showModal:false, checkErrorMessage: false})} closeIcon>
                        <Modal.Header>
							Confirm your password
                        </Modal.Header>
                        <Modal.Content>
                            <Message error hidden={!this.state.checkErrorMessage} content={this.state.checkErrorMessageText}/>
                            <Form size='small' onSubmit={this.checkPasswordSubmit.bind(this)} loading={this.state.checkLoading}>
                                <Form.Field>
                                    <label>Password</label>
                                    <input type='password' minLength='6' autoComplete='new-password' placeholder='Password' value={this.state.checkPassword} onChange={this.checkPasswordOnInputChange.bind(this)} />
                                </Form.Field>
                                <Form.Field>
                                    <label>Confirm Password</label>
                                    <input type='password' minLength='6' autoComplete='current-password' placeholder='Confirm Password' value={this.state.checkConfirmPassword} onChange={this.checkPasswordConfirmOnInputChange.bind(this)} />
                                </Form.Field>
                                <Button.Group size='small'>
                                    <Button positive type='submit'>Submit</Button>
                                </Button.Group>
                            </Form>
                        </Modal.Content>
                    </Modal>
                </Segment>
			)
        } 

        if(this.state.restoreWallet === 'cr') { 
            return(
                <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                    <Container>
                        <Header as='h1' content='Create Wallet' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                        <Container textAlign='left' text>
                            <Message error hidden={!this.state.errorMessage} content={this.state.errorMessageText}/>
                            <Form size='large' onSubmit={this.inputPasswordSubmit.bind(this)}>
                                <Form.Field width={6}>
                                    <label>Password</label>
                                    <input type='password' minLength='6' autoComplete='new-password' placeholder='New Password (min 6 char)' value={this.state.inputPassword} onChange={this.passwordOnInputChange.bind(this)} />
                                </Form.Field>
                                <Form.Field width={6}>
                                    <label>Confirm Password</label>
                                    <input type='password' minLength='6' autoComplete='current-password' placeholder='Confirm Password' value={this.state.inputConfirmPassword} onChange={this.passwordConfirmOnInputChange.bind(this)} />
                                </Form.Field>
                                <Button.Group size='large'>
                                    <Button positive type='submit'>Create</Button><Button.Or/><Button positive type='reset' onClick={() => this.setState({restoreWallet: 'rs', errorMessage: false, inputPassword: '', inputConfirmPassword: ''})}>Restore</Button>
                                </Button.Group>
                            </Form>
                        </Container>
                    </Container>
                </Segment>
			)
        }

        if(this.state.restoreWallet === 'dn') { 
            return(
                <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                    <Container>
                        <Header as='h1' content='Save Your Wallet' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                        <Container textAlign='left' text>
                            <p>Your new wallet seed is:</p>
                            <Message>
                                <CopyToClipboard text={this.state.seed} onCopy={this.copyToClipboard.bind(this)}>
                                    <span style={{cursor: 'pointer'}}>{this.state.seed}</span>
                                </CopyToClipboard>
                                {this.state.copySuccess ? <span> ✓</span> : ''}
                            </Message>
                            <p>Please write it down on paper or in a password manager, you will need it to access your wallet. Do not let anyone see this seed or they can take your Ether.</p>
                            <Button.Group size='large'>	
                                <Button positive onClick={this.downloadWallet.bind(this)}>Download Wallet</Button><Button.Or text='&'/><Button positive onClick={this.continueSubmit.bind(this)}>Continue</Button>
                            </Button.Group>
                        </Container>
                    </Container>
                </Segment>
			)
        }
    }
}


export default connect()(Wallet)

Wallet.propTypes = {
    dispatch: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/layouts/wallet/Wallet.js